import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import CardList from "components/common/CardList"
import Pagination from "react-js-pagination"
import { getUserCertificates } from "store/user/actions"
import { logoutUser } from "store/auth/action"
import Panel from "components/panel"
import Text from "components/text"
import { checkParams } from "helpers/util"
import { SORT_CERTIFICATES } from "constants/sort-values"
import "./index.scss"

class MyCertificates extends Component {
  constructor() {
    super()

    this.state = {
      activePage: 1,
      searchParam: "",
      typing: false,
      typingTimeout: 0,
      sort: "-timestamp",
    }
  }

  fetchUserCertificates = () => {
    const {
      getUserCertificates,
      auth: { userId },
    } = this.props
    const { status, searchParam, activePage, sort } = this.state

    let data = {
      pageNumber: `page=${activePage}`,
      rowsPerPage: `perpage=6`,
      statusParam: status ? `status=${status}` : "",
      searchParam: searchParam ? `course_name=${searchParam}` : "",
      sortParam: sort ? `sort=${sort}` : "",
    }

    getUserCertificates({ userId: userId, data: checkParams(data) })
  }

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber }, () =>
      this.fetchUserCertificates()
    )
  }

  handleFilterStatus = (event) => {
    const { name, value } = event.currentTarget
    this.setState({ [name]: value, activePage: 1 }, () =>
      this.fetchUserCertificates()
    )
  }

  handleChange = (e) => {
    const { name, value } = e.currentTarget

    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout)
    }

    this.setState({
      [name]: value,
      activePage: 1,
      typing: false,
      typingTimeout: setTimeout(() => {
        this.fetchUserCertificates()
      }, 500),
    })
  }

  render() {
    const {
      user: { certificates, isLoadingCertificates },
    } = this.props
    const { activePage, searchParam, sort } = this.state

    return (
      <div className="my-certificate">
        <Panel pad="40" grid>
          <Text text="My Certificate" type="headline" />
          <div className="filter-certificate">
            <div className="select-wrapper" id="sort">
              <select
                className="select"
                onChange={this.handleFilterStatus}
                value={sort}
                name="sort"
              >
                {SORT_CERTIFICATES &&
                  SORT_CERTIFICATES.map((item) => (
                    <option value={item.value} key={item.id}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>
            <input
              type="text"
              name="searchParam"
              value={searchParam}
              placeholder="Search"
              onChange={this.handleChange}
            />
          </div>
          <div className="certificate-table">
            {certificates ? (
              <CardList
                data={certificates.data}
                type="certificate"
                loading={isLoadingCertificates}
              />
            ) : (
              <div>No data to display</div>
            )}
          </div>
          <Pagination
            prevPageText="Prev"
            nextPageText="Next"
            hideFirstLastPages
            pageRangeDisplayed={5}
            activePage={activePage}
            itemsCountPerPage={6}
            totalItemsCount={certificates.count ? certificates.count : 0}
            onChange={this.handlePageChange}
            innerClass="card-pagination"
            itemClass="pagination-item"
            itemClassPrev="pagination-action"
            itemClassNext="pagination-action"
            disabledClass="action-disabled"
            activeClass="item-active"
          />
        </Panel>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.userReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserCertificates,
      logoutUser,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(MyCertificates)
